// extracted by mini-css-extract-plugin
export default {"container":"NotesComponent_container__JrPQV","notes_container":"NotesComponent_notes_container__1oI9j"};